import React, { Fragment } from "react";
import { Field, FieldArray, useFormikContext } from "formik";
import { v4 as uuid } from "uuid";
import Label from "components/FormElements/Label";
import TextInput from "components/FormElements/TextInput";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { PlusIcon, TrashIcon } from "@heroicons/react/outline";

export default function Clips(props) {
    const { values } = useFormikContext();

    return (
        <div>
            <div className="pb-2">
                <Label>Clips</Label>
                <div className="mt-1 text-xs text-gray-500">
                    Clips are short, reuseable pieces of code that can be reused
                    in the article editor.
                </div>
            </div>
            <FieldArray name="clips">
                {({ insert, remove, push }) => (
                    <div className="space-y-4">
                        {values.clips?.length > 0 &&
                            values.clips.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-end space-x-4"
                                >
                                    <TextInput
                                        name={`clips.${index}.label`}
                                        placeholder="Label"
                                        type="text"
                                        label={index === 0 ? "Label" : null}
                                    />
                                    <div className="flex-grow">
                                        <TextInput
                                            name={`clips.${index}.value`}
                                            type="text"
                                            placeholder="Value"
                                            label={index === 0 ? "Value" : null}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        className="secondary"
                                        onClick={() => remove(index)}
                                    >
                                        <TrashIcon className="h-5 w-5 md:mb-3" />
                                    </button>
                                    <Field
                                        name={`clips.${index}.id`}
                                        type="hidden"
                                    />
                                </div>
                            ))}
                        <SecondaryButton
                            type="button"
                            className="flex"
                            onClick={() =>
                                push({
                                    id: uuid(),
                                    label: "",
                                    value: "",
                                })
                            }
                            label={
                                <Fragment>
                                    <PlusIcon className="mt-0.5 mr-1 h-4 w-4" />
                                    Add Clip
                                </Fragment>
                            }
                        />
                    </div>
                )}
            </FieldArray>
        </div>
    );
}
